import React from 'react';
import { HANDIN_PROVIDER } from '@core/assignments/constants';
import {
  Alert,
  Box,
  Button,
  Modal,
  Typography,
  useTheme,
} from '@ublend-npm/aulaui-core';
import StudentRow from '../../../components/StudentRow';
import { EXISTING_SUBMISSION_CONFLICT_MESSAGES } from '../../../constants';
import { createStyles } from './ExistingSubmissionErrorDialog.styles';
import { EXISTING_SUBMISSIONS_FOUND } from '../../constants';

const getOperationCouldNotBeCompletedText = (isConversion) => {
  const baseText =
    EXISTING_SUBMISSION_CONFLICT_MESSAGES.operationCouldNotBeCompleted;

  if (isConversion) {
    const destinationAssignmentText =
      EXISTING_SUBMISSION_CONFLICT_MESSAGES.destinationAssignment;
    return `${baseText} ${destinationAssignmentText}.`;
  }

  return `${baseText}.`;
};

const getHandinErrorText = (isConversion) => {
  return `${getOperationCouldNotBeCompletedText(isConversion)}
  ${EXISTING_SUBMISSION_CONFLICT_MESSAGES.handinAction}
`;
};

const getTurnitinErrorText = (isConversion) => {
  return `${getOperationCouldNotBeCompletedText(isConversion)}
  ${EXISTING_SUBMISSION_CONFLICT_MESSAGES.turnitinAction}
`;
};

const extensionWithSubmissionErrorText =
  EXISTING_SUBMISSION_CONFLICT_MESSAGES.currentExtension;

type ExistingSubmissionErrorDialogProps = {
  open: boolean;
  provider: string;
  students?: any[];
  onClose?: () => void;
  isConversion?: boolean;
  errorCode?: string;
};

const ExistingSubmissionErrorDialog = (
  props: ExistingSubmissionErrorDialogProps
) => {
  const {
    open = true,
    provider,
    students = [],
    onClose = () => {},
    isConversion = false,
    errorCode = '',
  } = props;

  const styles = createStyles(useTheme());

  const providerErrorText =
    provider === HANDIN_PROVIDER
      ? getHandinErrorText(isConversion)
      : getTurnitinErrorText(isConversion);

  const errorText =
    errorCode === 'extension-submissions-exist'
      ? extensionWithSubmissionErrorText
      : providerErrorText;

  const getStudentsContent = () => {
    return students?.map((student: any) => {
      return (
        <StudentRow
          key={student?.id}
          canAdd={false}
          isSelected={false}
          onToggle={() => {}}
          showAction={false}
          student={student}
        />
      );
    });
  };

  return (
    <Modal open={open} onClose={onClose}>
      <Box sx={styles.container}>
        <Box sx={styles.content}>
          <Typography component="h3" sx={styles.title}>
            {EXISTING_SUBMISSIONS_FOUND}
          </Typography>
          <Alert severity="error">{errorText}</Alert>
          <Box component="ul" sx={styles.studentList}>
            {getStudentsContent()}
          </Box>
          <Box sx={styles.actions}>
            <Button kind="secondary" onClick={onClose}>
              {EXISTING_SUBMISSION_CONFLICT_MESSAGES?.close}
            </Button>
          </Box>
        </Box>
      </Box>
    </Modal>
  );
};

export default React.memo(ExistingSubmissionErrorDialog);
